import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-center text-sm leading-5 font-semibold" }

import { computed } from "vue"

interface Props {
    title: string
    disabled?: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ActionCard',
  props: {
    title: {},
    disabled: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props

const style = computed(() => [
    props.disabled ? "text-gray-400 cursor-not-allowed" : "cursor-pointer text-gray-900",
    "w-[98px] h-[94px] border border-gray-200 rounded-lg shadow-sm flex flex-col gap-y-2.5 px-4 items-center justify-center",
])

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(style.value)
  }, [
    _renderSlot(_ctx.$slots, "default"),
    _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.title), 1)
  ], 2))
}
}

})